import { render, staticRenderFns } from "./CareDialog.vue?vue&type=template&id=08f7ed3c&scoped=true"
import script from "./CareDialog.vue?vue&type=script&lang=js"
export * from "./CareDialog.vue?vue&type=script&lang=js"
import style1 from "./CareDialog.vue?vue&type=style&index=1&id=08f7ed3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7ed3c",
  null
  
)

export default component.exports